import {
  FIND_RIDE_ANY_TIME,
  FIND_RIDE_CONTEXT,
} from "../constants/findRide.constants";
import type { FindRideSearchCriteria } from "../types/findRide.types";

function appendIfPresent(
  params: URLSearchParams,
  key: string,
  value: string | null | undefined
) {
  const trimmed = value?.trim();
  if (trimmed) params.set(key, trimmed);
}

/** Builds GET /rides query params (keeps spelling `formlocation`). */
export function buildFindRideQuery(
  criteria: FindRideSearchCriteria
): URLSearchParams {
  const { pickup, drop, date, seats } = criteria;
  const seatCount = Math.max(1, Math.floor(seats) || 1);

  const params = new URLSearchParams({
    context: FIND_RIDE_CONTEXT,
    formlocation: pickup.address,
    fromcity: pickup.city,
    fromarea: pickup.area,
    fromlat: String(pickup.lat),
    fromlong: String(pickup.lng),
    tolocation: drop.address,
    tocity: drop.city,
    toarea: drop.area,
    tolat: String(drop.lat),
    tolong: String(drop.lng),
    date,
    time: FIND_RIDE_ANY_TIME,
    numberofseats: String(seatCount),
  });

  appendIfPresent(params, "fromstate", pickup.state);
  appendIfPresent(params, "tostate", drop.state);

  return params;
}
